// Function to check the status of a license
const API_BASE_URL = wpsmsHelper.apiUrl
const checkLicenseStatus = async (licenseKey, order_id) => {
    const apiUrl = `${API_BASE_URL}license/domains?license_key=${encodeURIComponent(licenseKey)}&order_id=${encodeURIComponent(order_id)}`;
    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': wpsmsHelper.nonce  // Use nonce from localized script
            }
        });
        return response.json();
    } catch (error) {
        console.error('Failed to check license status:', error);
    }
};


// Function to update domains for a license
const updateDomainsForLicense = async (licenseKey, domains, order_id) => {
    const apiUrl = `${API_BASE_URL}license/update-domain`;
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': wpsmsHelper.nonce  // Use nonce from localized script
            },
            body: JSON.stringify({ license_key: licenseKey, domains, order_id  })
        });
        return response.json();
    } catch (error) {
        console.error('Failed to update domains:', error);
    }
};

export {checkLicenseStatus, updateDomainsForLicense}
